export const EXAM_TYPES = {
  hazardQuestions: {
    title: 'Gevaarherkenning',
    query: 'hazardQuestions',
    maxLength: 25,
  },
  knowledgeQuestions: {
    title: 'Kennis',
    query: 'knowledgeQuestions',
    maxLength: 12,
  },
  insightQuestions: {
    title: 'Inzicht',
    query: 'insightQuestions',
    maxLength: 28,
  },
};

export const NON_AUTO_EXAM_TYPES = {
  nonAutoQuestions: {
    title: 'Non-Auto',
    query: 'nonAutoQuestions',
    maxLength: 50,
  },
}

export const AUTO_EXAM_TYPES = {
  autoQuestions: {
    title: 'Auto',
    query: 'autoQuestions',
    maxLength: 50,
  },
}